import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { getAllCOE } from "../../../services/adminServices/CoeServices";
import { getAllLabs } from "../../../services/mentorServices/MentorServices";
import LabPracticeModal from './LabPracticeModal';
import LabPracticeTable from './LabPracticeTable';
import { toast } from 'react-toastify';

const LabPractice = () => {
    const [openModal, setOpenModal] = useState({ userForm: false });
    const [rowData, setRowData] = useState([]);
    const [editRowData, setEditRowData] = useState(null);
    const [allCOE, setCOE] = useState([]);
    const [loadingData, setLoadingData] = useState(true);

    const handleModalToggle = (modalName, data = null) => {
        setOpenModal((prev) => ({ ...prev, [modalName]: !prev[modalName] }));
        if (!data) setEditRowData(null)
        else setEditRowData(data)
    };

    const getAllLabsData = async () => {
        try {
            setLoadingData(true)
            const response = await getAllLabs();
            const allCOE = await getAllCOE();
            setCOE(allCOE?.data?.data || []);
            setRowData(response?.data?.data || []);
            setLoadingData(false);

        } catch (error) {
            toast.error(error?.response?.data.message || error?.message || error?.error);
        }
    };

    useEffect(() => {
        getAllLabsData();
    }, []);

    const handleEditClick = (data) => {
        handleModalToggle('userForm', data);
    };

    return (
        <Box className="dashboard-container">
            <Box className="dashboard-header">
                <Typography className="dashboard-header-title">Welcome {JSON.parse(localStorage.getItem("user"))?.name}</Typography>
                {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleModalToggle('userForm')}
                    className="dashboard-header-button"
                >
                    CREATE LAB
                </Button> */}
            </Box>
            <LabPracticeModal
                open={openModal.userForm}
                onClose={() => handleModalToggle('userForm')}
                editRowData={editRowData}
                getAllLabsData={getAllLabsData}
                allCOE={allCOE}
            />
            <Box className="dashboard-box-container">
                <LabPracticeTable
                    loadingData={loadingData}
                    setLoadingData={setLoadingData}
                    rowData={rowData}
                    handleEditClick={handleEditClick}
                    getAllLabsData={getAllLabsData}
                />
            </Box>
        </Box>
    );
};

export default LabPractice;
